import React from "react";

export default function GuestList() {
  const guests = [
    {
      name: "Sufyan",
      age: 22,
      status: "Acceptable",
      date: "6/4/2000",
      role: "Developer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Stevens",
      age: 27,
      status: "Pending",
      date: "6/10/2020",
      role: "Programmer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Nora",
      age: 17,
      status: "Unacceptable",
      date: "6/10/2020",
      role: "Designer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Ali",
      age: 23,
      status: "Acceptable",
      date: "6/10/2020",
      role: "Programmer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Khalid",
      age: 20,
      status: "Pending",
      date: "6/10/2020",
      role: "Designer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Nasser",
      age: 29,
      status: "Acceptable",
      date: "6/10/2020",
      role: "Pen Tester",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Mohammed",
      age: 38,
      status: "Acceptable",
      date: "6/10/2020",
      role: "Web Designer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Saad",
      age: 19,
      status: "Acceptable",
      date: "6/10/2020",
      role: "Data",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
    {
      name: "Sami",
      age: 21,
      status: "Acceptable",
      date: "6/10/2020",
      role: "Developer",
      image:
        "https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    },
  ];

  return (
    <div className="sm:p-6 p-0 bg-background min-h-screen">
      <section className="container mx-auto sm:p-6 p-0 font-poppina">
        <div className="w-full mb-8 overflow-hidden rounded-lg shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="w-full border border-border ">
              <thead>
                <tr className="text-sm font-semibold tracking-wide text-left text-text bg-background uppercase border-b border-border">
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Age</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Date</th>
                </tr>
              </thead>
              <tbody className="bg-background">
                {guests.map((guest, index) => (
                  <tr key={index} className="text-text">
                    <td className="px-4 py-3 border border-border ">
                      <div className="flex items-center text-sm">
                        <div className="relative w-8 h-8 mr-3 rounded-full">
                          <img
                            className="object-cover w-full h-full rounded-full"
                            src={guest.image}
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <div>
                          <p className="font-semibold text-text">
                            {guest.name}
                          </p>
                          <p className="text-xs text-gray-600">{guest.role}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm font-semibold border border-border">
                      {guest.age}
                    </td>
                    <td className="px-4 py-3 text-xs border border-border">
                      <span
                        className={`px-2 py-1 font-semibold  leading-tight rounded-sm ${
                          guest.status === "Acceptable"
                            ? "text-green-700 bg-green-100"
                            : guest.status === "Pending"
                            ? "text-orange-700 bg-orange-100"
                            : "text-red-700 bg-red-100"
                        }`}
                      >
                        {guest.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm border border-border">{guest.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}